import config from '../api.config.json';

export function iOS() {
    // Chrome 1 - 79
    // var isChrome =
    //   !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);

    let iOS =
        ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(
            navigator.platform
        ) ||
        // iPad on iOS 13 detection
        (navigator.userAgent.includes('Mac') && 'ontouchend' in document);

    // console.log("iOS", iOS, "chrome", isChrome);
    if (iOS) {
        return true;
    } else return false;
}

/* Check the method user used to enter => act accordingly */
export function checkNavigationType() {
    var result;
    var p;

    if (window.performance.navigation) {
        result = window.performance.navigation;
        if (result == 255) {
            result = 4;
        } // 4 is my invention!
    }
    try {
        if (window.performance.getEntriesByType('navigation')) {
            p = window.performance.getEntriesByType('navigation')[0].type;

            if (p == 'navigate') {
                result = 0;
            }
            if (p == 'reload') {
                result = 1;
            }
            if (p == 'back_forward') {
                result = 2;
            }
            if (p == 'prerender') {
                result = 3;
            } //3 is my invention!
        }
        // console.log("navigtion type:::", result);
        return result;
    } catch (error) {
        console.log(error);
    }
}

export function addStyle(styleString) {
    const style = document.createElement('style');
    style.textContent = styleString;
    document.head.append(style);
}

/* Check Password format */
export function checkPwd(pwd) {
    // 密碼必須包含8至20個字元，包括字母、數字及最少一個大寫字母和一個小寫字母。
    let regrex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,20}$/;
    if (regrex.test(pwd)) {
        return true;
    } else return false;
}

export function apiBaseUrl() {
    switch (window.location.origin) {
        /* Live Prod */
        case config.prod_domain:
            return config.prod_api_base_url;
        /* UAT */
        case config.uat_domain:
            return config.uat_api_base_url;
        /* DEV */
        default:
            return config.uat_api_base_url;
    }
}

export function getMedia(mediaToken, isPrivate) {
    // TODO:: may need to handle private
    return `${apiBaseUrl()}media/${mediaToken}`;
}
